// extracted by mini-css-extract-plugin
module.exports = {"ul":"styles_ul__qKaza","icon":"styles_icon__37b8h","burger":"styles_burger__1QHXN","search":"styles_search__30qVb","drawer":"styles_drawer__21R9Y"};